import DataStore from 'flux/stores/DataStore.js'
import Form from './Form';
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps"
import mapstyle from './mapstyle.json'
import ReactGA from 'react-ga';


class Contact extends React.Component {
  constructor () {
    super()
    ReactGA.pageview(window.location.pathname + window.location.search);

    const languages = DataStore.getAllLanguages()

    const split = window.location.pathname.split('/')
    
    const url_string = window.location.href
    const url = new URL(url_string);
    const name = url.searchParams.get('name');
    const submitted = url.searchParams.get('emailsent')


    let lang = 'sv'
    if (languages.includes(split[1])) {
      lang = split[1]
    }

    let pageData = DataStore.getPageBySlug(split[split.length - 1], lang);

    this.state = {
      emailSent: !!submitted,
      name: name,
      content: pageData.content.rendered,
      contactInfo: pageData.acf.contactInfo,
      contactContent2: pageData.acf.contactContent2,
      lang: lang
    }
  }

  render() {
    return (
      <div className="page page--contact">
        {/* { !pageData.acf.headerImage && 
          <div className="page__header page__header--noimg">
            <h1 className="page__header__title">{ pageData.title.rendered }</h1>
          </div>
        } */}

        <MyMapComponent
          googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&key=AIzaSyBEpxtSJbyoABi8aXfxQZaqzLy7kY6qbac&libraries=geometry,drawing,places"
          loadingElement={<div style={{ height: `100%` }} />}
          containerElement={<div className="contact__map" />}
          mapElement={<div style={{ height: `100%` }} />}
        />

        <div className="contact">
          <div className="contact__content">
            <div className="padding wysiwyg" dangerouslySetInnerHTML={{__html: this.state.content }}/>

            { this.state.contactInfo && 
              <div className="contact__info">
                <div className="padding wysiwyg" dangerouslySetInnerHTML={{__html: this.state.contactInfo }}/>
              </div>
            }

            { this.state.contactContent2 && 
              <div className="padding wysiwyg" dangerouslySetInnerHTML={{__html: this.state.contactContent2 }}/>
            }
            
            
          </div>

          <div className="contact__content">
            <Form submitted={this.state.emailSent} name={this.state.name} lang={this.state.lang}/>
          </div>
        </div>

      </div>
    );
  }
}

const MyMapComponent = withScriptjs(withGoogleMap((props) =>
  <GoogleMap
    defaultZoom={9}
    defaultCenter={{ lat: 60.215096, lng: 19.605147 }}
    defaultOptions={{
      styles: mapstyle,
      streetViewControl: false,
      mapTypeControl: false,
      fullscreenControl: false,
    }}
  >
    <Marker
      position={{ lat: 60.215096, lng: 19.605147 }}
      defaultIcon="/src/assets/pin.svg"
    />
  </GoogleMap>
))


export default Contact;



// WEBPACK FOOTER //
// ./src/scripts/components/Contact.js